import {
  OPEN_DROPDOWN,
  CLOSE_DROPDOWN,
  INIT_DROPDOWN,
  NOTIFICATIONS_LOADED,
  NEW_NOTIFICATION,
  MARK_AS_READ
} from './action-types';


let initialState = {
  opened: false,
  closed: true
};

export function dropdownReducer(state = initialState, { type, payload }) {
  switch (type) {
    case INIT_DROPDOWN:
      return Object.assign({}, state, initialState);
    case OPEN_DROPDOWN:
      return Object.assign({}, state, {
        opened: true,
        closed: false
      });
    case CLOSE_DROPDOWN:
      return Object.assign({}, state, {
        opened: false,
        closed: true
      });
    case NOTIFICATIONS_LOADED:
      return Object.assign({}, state, {
        notifications: payload,
        unreadCount: payload.filter(n => !n.read).length
      });
    case NEW_NOTIFICATION: //eslint-disable-line no-case-declarations
      const notifications = [payload].concat(state.notifications).filter(n => n);
      return Object.assign({}, state, {
        notifications,
        unreadCount: notifications.filter(n => !n.read).length
      });
    case MARK_AS_READ: //eslint-disable-line no-case-declarations
      let filtered = state.notifications.filter(n => parseInt(payload.split('/')[5]) === n.id);

      if (filtered.length) {
        let n = filtered[0];
        n.read = true;
        return Object.assign({}, state, {
          unreadCount: state.notifications.filter(n => !n.read).length
        });
      } else {
        return state;
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/core/services/notifications/dropdown/reducer.js